<template>
  <FlotoAnchorLink
    :aria-label="`${$t('remove')} ${$t('barcode')}`"
    @click="triggerAction"
  >
    <MIcon name="trash-alt" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('remove') }} {{ $t('barcode') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="trash-alt" class="w-full text-secondary-red" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_remove_item', {
            item: $tc('barcode'),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'DeleteBarcode',
  props: {
    handleDeleteBarcode: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleDeleteBarcode) {
        this.processing = true
        this.handleDeleteBarcode()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
